module.exports = __webpack_public_path__ + "img/57exp.e8853024.jpg";